<template lang="pug">
  div(v-if="ctrGoal > 0") {{ ratioShort }}
    div.text-muted(v-b-tooltip.hover.right, :title="ratioText") {{ ratioMini }}
</template>

<style lang="scss"></style>

<script>
import { impressionRateToCtrGoal } from "@/utils/impression-rate-ctr-goal";

export default {
  name: "CtrGoalDisplay",
  props: {
    value: {
      type: [String, Number],
    },
  },
  computed: {
    ctrGoal() {
      // Convert stored `impression_rate` to UI CTR Goal.
      return impressionRateToCtrGoal(this.value);
    },
    ratioText() {
      // Provide a readable explanation for the tooltip.
      const p = this.ctrGoal;
      if (!p || p <= 0) return "";
      if (this.value === 100) return "Only impressions";
      if (this.value === 0) return "Only clicks";
      const imprPerClick = 100 / p;
      if (!Number.isFinite(imprPerClick)) return `${p}% clicks per impression`;
      return `${parseFloat(imprPerClick.toFixed(2))} impressions per click`;
    },
    ratioShort() {
      // Keep list rows compact (single line).
      const p = this.ctrGoal;
      if (!p || p <= 0) return "";
      return `${p}%`;
    },
    ratioMini() {
      // Secondary hint in the same style as ImpressionRatioDisplay (e.g. 1/4).
      const p = this.ctrGoal;
      if (!p || p <= 0) return "";
      const imprPerClick = 100 / p;
      if (!Number.isFinite(imprPerClick)) return "";
      return `1/${parseFloat(imprPerClick.toFixed(2))}`;
    },
  },
};
</script>

